import { NewTooltip } from '@lib/components'
import { Avatar, DropdownMenu } from '@octopus-do/octopus-storybook'
import { forwardRef } from 'react'

import { useAuth } from '@/hooks'
import css from './styles.module.css'

export const AvatarButton = forwardRef<HTMLButtonElement>((_, ref) => {
  const { active, toggle } = DropdownMenu.useTrigger()

  const { fullName, color, avatar } = useAuth()
  const media = avatar || null

  return (
    <NewTooltip
      content="Profile"
      renderEl={(onSetRef, onMouseEnter, onMouseLeave) => (
        // A second click closes the menu: the kit keeps the trigger out of
        // the menu's outside-click dismissal and leaves the toggle to it.
        // The tooltip hides with the click and stays off while the menu is
        // open, or it peeks out from under the menu.
        <button
          data-testid="profile_avatar"
          className={css.avatar_button}
          ref={ref}
          onPointerDown={() => {
            onMouseLeave()
            toggle()
          }}
        >
          <div
            className={css.avatar}
            data-testid="profile_avatar"
            ref={onSetRef}
            onMouseEnter={() => {
              if (!active) {
                onMouseEnter()
              }
            }}
            onMouseLeave={onMouseLeave}
          >
            <Avatar name={fullName} color={color} media={media} size="md" />
          </div>
        </button>
      )}
    />
  )
})
